import { useEffect, useState } from 'react';
import { useDesktopMode } from '../../contexts/DesktopModeContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { House, GraduationCap, CircleCheckBig, Truck, Menu, Users, FileSignature, Pen, Book, Shirt, LogOut } from 'lucide-react';
import { PortalMenuSheet } from './PortalMenuSheet';
import { readPortalCache } from './portalCache';

const VERBORGEN = ['/employee/portal', '/login', '/'];

// Vaste onderbalk op alle medewerkerpagina's (behalve het startscherm, dat heeft een eigen balk)
export const EmployeeAppNav = ({ user, onLogout }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const { desktopMode, toggleDesktopMode } = useDesktopMode();
  // Medewerkers gebruiken altijd de telefoonweergave
  useEffect(() => {
    if (user?.role === 'employee' && desktopMode) toggleDesktopMode();
  }, [user?.role, desktopMode]);
  if (user?.role !== 'employee' || VERBORGEN.includes(pathname)) return null;

  const academy = !!(user?.academy_enabled || user?.onboarding_completed);
  const sectie = (s) => navigate('/employee/portal', { state: { sectie: s } });
  const items = [
    { key: 'dashboard', label: 'Dashboard', icon: House, to: '/employee/portal' },
    academy && { key: 'academy', label: 'Academy', icon: GraduationCap, to: '/mijn-academy' },
    { key: 'opdrachten', label: 'Opdrachten', icon: CircleCheckBig, to: '/employee/opdrachten' },
    { key: 'voertuigen', label: 'Voertuigen', icon: Truck, to: readPortalCache(user?.id).vr ? '/employee/voertuigregistratie' : '/employee/voertuig-controle' },
  ].filter(Boolean);

  return (
    <>
      <div className="h-24 md:hidden" aria-hidden />
      <nav className="ep-bottomnav fixed bottom-0 inset-x-0 z-40 md:hidden" data-testid="app-bottom-nav">
        <div className="flex justify-around items-stretch px-2 pt-2 pb-[max(10px,env(safe-area-inset-bottom))]">
          {items.map(({ key, label, icon: Icon, to }) => {
            const active = key === 'voertuigen' ? pathname.startsWith('/employee/voertuig') : key === 'academy' ? (pathname.startsWith('/mijn-academy') || pathname.startsWith('/academy')) : pathname.startsWith(to);
            return (
              <button key={key} type="button" onClick={() => navigate(to)} data-testid={`app-nav-${key}`}
                className={`flex flex-col items-center gap-1 px-2 py-1 text-[11px] transition-colors ${active ? 'text-blue-400' : 'text-slate-300 hover:text-white'}`}>
                <Icon className="w-6 h-6" strokeWidth={active ? 2.4 : 1.8} />
                {label}
              </button>
            );
          })}
          <button type="button" onClick={() => setMenuOpen(true)} data-testid="app-nav-menu"
            className="flex flex-col items-center gap-1 px-2 py-1 text-[11px] text-slate-300 hover:text-white">
            <Menu className="w-6 h-6" strokeWidth={1.8} />
            Menu
          </button>
        </div>
      </nav>
      <PortalMenuSheet
        open={menuOpen}
        onOpenChange={setMenuOpen}
        items={[
          user?.is_academy_mentor && { key: 'mentor', label: 'Mentor', icon: Users, onClick: () => navigate('/mentor/academy') },
          { key: 'kleding', label: 'Mijn Kleding', icon: Shirt, onClick: () => sectie('assignments') },
          { key: 'documenten', label: 'Documenten', icon: FileSignature, onClick: () => sectie('documents') },
          { key: 'huisregels', label: 'Huisregels', icon: Book, onClick: () => sectie('huisregels') },
          { key: 'bus', label: 'Bus controle', icon: Truck, onClick: () => navigate('/employee/voertuig-controle') },
          { key: 'handtekening', label: 'Handtekening', icon: Pen, onClick: () => navigate('/handtekening') },
          { key: 'hulp', label: 'Hulp', icon: Book, onClick: () => navigate('/handboek') },
          { key: 'logout', label: 'Uitloggen', icon: LogOut, onClick: onLogout, danger: true },
        ]}
      />
    </>
  );
};
